var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wb-eco-rating',{staticClass:"fcis-eco-rating",attrs:{"rating":_vm.value,"locale":_vm.getLocale,"emission":_vm.currentEmissions,"year":"2026"}})}
var staticRenderFns = []

export { render, staticRenderFns }